import { KycVerificationStatusEnumType } from "@oysterhr/schema"

export const {
  Abandoned,
  Approved,
  Declined,
  Expired,
  ResubmissionRequired,
  Started,
  Submitted,
  NotStarted,
} = KycVerificationStatusEnumType

export enum Severity {
  Error = "error",
  Warning = "warning",
  Info = "info",
}

const reverifyBanner = {
  severity: Severity.Error,
  textKey: "reverifyText",
  buttonKey: "reverifyProfile",
  shouldCreateNewVerification: true,
}

export const VerificationBannerByStatus = {
  [Abandoned]: reverifyBanner,
  [Approved]: null,
  [Declined]: null,
  [Expired]: reverifyBanner,
  [ResubmissionRequired]: reverifyBanner,
  [Started]: {
    severity: Severity.Warning,
    textKey: "continueVerificationText",
    buttonKey: "continueVerification",
    shouldCreateNewVerification: false,
  },
  [Submitted]: null,
  [NotStarted]: {
    severity: Severity.Info,
    textKey: "unverifiedText",
    buttonKey: "verifyProfile",
    shouldCreateNewVerification: false,
  },
}
